import { filterVisibleItems } from '../../../../utils/common'
import { getChartValueShare } from '../../../Chart'

export function getBirdviewAgingChartTooltipRows({ bucket, label, t, total }) {
  const { cumulative, minDays } = bucket.payload

  return filterVisibleItems([
    {
      id: label,
      isVisible: true,
      value: t('DashboardBirdview.AgingTooltipRowKey', {
        count: bucket.value,
        share: getChartValueShare(bucket.value, total),
      }),
    },
    {
      id: minDays,
      isVisible: Boolean(cumulative),
      value: t('DashboardBirdview.AgingTooltipCumulativeKey', {
        count: cumulative,
        min: minDays,
      }),
    },
  ])
}
